module.exports = __webpack_public_path__ + "./images/9453de2fb08aeb1e4dab9c9904d0b155.webp";